import React, { useEffect, useState } from "react";
import { getUrl, list } from "aws-amplify/storage";
import Modal from "react-modal";
import PublicLayout from "../../components/layout/PublicLayout";
import { BookViewer, Libros } from "../../components/shared";

const STORAGE_ROOT = "resolucion-de-libros/";
const JPG_FILE = /\.jpe?g$/i;

const isImageFile = (item) => item.size && JPG_FILE.test(item.path);

export default function ResolucionLibros() {
  const [libros, setLibros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isBookViewerOpen, setBookViewerOpen] = useState(false);
  const [selectedBookPages, setSelectedBookPages] = useState([]);

  useEffect(() => {
    const fetchLibros = async () => {
      try {
        const { items } = await list({
          path: STORAGE_ROOT,
          options: { listAll: true },
        });
        const librosPorCarpeta = new Map();

        items.filter(isImageFile).forEach((item) => {
          const [nombre, tipo, archivo, ...resto] = item.path
            .slice(STORAGE_ROOT.length)
            .split("/");

          if (!nombre || resto.length || !archivo) return;
          if (tipo !== "miniatura" && tipo !== "paginas") return;

          const libro = librosPorCarpeta.get(nombre) || {
            name: nombre,
            miniaturas: [],
            paginas: [],
          };

          libro[tipo === "miniatura" ? "miniaturas" : "paginas"].push(
            item.path,
          );
          librosPorCarpeta.set(nombre, libro);
        });

        const librosConUrls = await Promise.all(
          [...librosPorCarpeta.values()]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(async (libro) => {
              const [miniatura] = libro.miniaturas.sort((a, b) =>
                a.localeCompare(b),
              );
              const paginas = libro.paginas.sort((a, b) => a.localeCompare(b));

              if (!miniatura || !paginas.length) return null;

              const [{ url: imageUrl }, ...pageUrls] = await Promise.all([
                getUrl({ path: miniatura }),
                ...paginas.map((path) => getUrl({ path })),
              ]);

              return {
                name: libro.name,
                image: imageUrl.href,
                pages: pageUrls.map(({ url }) => url.href),
              };
            }),
        );

        setLibros(librosConUrls.filter(Boolean));
      } catch (error) {
        console.error("Error al obtener las resoluciones de libros:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLibros();
  }, []);

  const openBookViewer = (libro) => {
    setSelectedBookPages(libro.pages);
    setBookViewerOpen(true);
  };

  const closeBookViewer = () => {
    setBookViewerOpen(false);
  };

  return (
    <PublicLayout>
      {loading ? (
        <div className="py-10 text-center">Cargando libros...</div>
      ) : (
        <Libros
          products={libros}
          text="Resolución de libros"
          onProductClick={openBookViewer}
        />
      )}

      <Modal
        isOpen={isBookViewerOpen}
        onRequestClose={closeBookViewer}
        contentLabel="Visor de libro"
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.75)", zIndex: 1000 },
          content: {
            width: "80vw",
            height: "90vh",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "0",
            border: "none",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div style={{ position: "relative" }}>
          <button
            onClick={closeBookViewer}
            className="absolute right-2 top-2 z-50 rounded bg-red-600 px-3 py-1 font-bold text-white"
          >
            Cerrar
          </button>
          <BookViewer pages={selectedBookPages} />
        </div>
      </Modal>
    </PublicLayout>
  );
}
